import Vue from 'vue'
import Router from 'vue-router'
import Credentials from "@/components/Auth/Credentials";
import Login from '@/components/Auth/Login'
import Register from '@/components/Auth/Register'
import PortalAuth from '@/components/Portal/PortalAuth'
import PortalLister from '@/components/Portal/PortalLister'
import Error from '@/components/Generic/Error'
import AuthService from '../services/AuthService'

Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login,
      beforeEnter: (to, from, next) => {
        AuthService.guard(to, from, next, false);
      }
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
      beforeEnter: (to, from, next) => {
        AuthService.guard(to, from, next, false);
      }
    },
    {
      path: '/portals',
      name: 'portals',
      component: PortalLister,
      beforeEnter: (to, from, next) => {
        AuthService.guard(to, from, next, true);
      }
    },
    {
      path: '/error',
      name: 'error',
      component: Error
    },
    {
      path: '/portal/:portal_name/:portal_id/:portal_url',
      name: 'portal_auth',
      component: PortalAuth,
      beforeEnter: (to, from, next) => {
        AuthService.guard(to, from, next, true);
      }
    },
    {
      path: '/credentials',
      name: 'credentials',
      component: Credentials,
      props: true,
      beforeEnter: (to, from, next) => {
        AuthService.guard(to, from, next, true);
      }
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js